import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService,UserService } from "@bt/core";

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService,private UserService: UserService) {}

  public canActivate() {
    if (this.authService.isAuth()) {
      var t=this;
      this.UserService
      .getUser()
      .then(
        (response) => {

          if (response.data.role == 1 || response.data.role == 0) {
            this.router.navigateByUrl("app/domains");
          }
          else if (response.data.role == 2) {
            this.router.navigateByUrl("app/all-users");
          }

        },
      )
      .catch((error) => {
        console.error(error.error);
        this.authService.logout();
      });
      return false;
    } else {
        return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/login.guard.ts